(function() {
  function main() {
    const page_navigations = document.querySelectorAll('.js-page-navigation');
    for (let i = 0; i < page_navigations.length; i++) {
      const nav = page_navigations[i];

      const toggles = nav.querySelectorAll('.js-page-navigation-toggle');
      for (let j = 0; j < toggles.length; j++) {
        const toggle = toggles[j];
        toggle.addEventListener('click', () => handleClick(nav));
      }
    }
  }

  function handleClick(element) {
    element.classList.toggle('is-open');
  }

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    main();
  } else {
    document.addEventListener('DOMContentLoaded', main);
  }
})();
